
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/job-orders?${queryString}`);
    return response.data;
  },
   async getStatics(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/job-orders-statistics?${queryString}`);
    return response.data;
  },
  async getById(id) {
    const response = await https.get(`/job-orders/${id}`);
    return response.data.data;
  },
  async getMailById(id) {
    const response = await https.get(`/job-order-mail/${id}`);
    return response.data;
  },
   async getPdfById(id) {
    const response = await https.get(`/job-order-pdf/${id}`);
    return response.data;
  },
  async add(payload) {
    const response = await https.post(`/job-orders`, payload);
    return response.data;
  },
  async printLabel(payload) {
    const response = await https.post(`/print-labels`, payload);
    return response.data;
  },
     async updateStatus(id, formData) {
    const response = await https.post(`/job-order-status/${id}`, formData); // <- use POST not PUT
    return response.data;
  },
  async update(id, formData) {
    const response = await https.post(`/job-orders/${id}`, formData); // <- use POST not PUT
    return response.data;
  },
  async deleteById(id) {
    const response = await https.delete(`/job-orders/${id}`);
    return response.data;
  },
});
